import Link from '~/components/Link'

export default ({ document }) => <li className='regulations__item'>
  <span className='regulations__icon i-document' />
  <Link
    className='regulations__link'
    route='regulation'
    params={{ id: document.id }}
  >
    {document.title}
  </Link>
</li>
